module.exports = __webpack_public_path__ + "static/media/candy-corn.0485b596.svg";